export const PERMIT_FIELD_TYPE=[
    'Text input',
    'Title & Description',
    'Select Box',
    'Table',
    'Dropdown',
    'Date',
    'Worker Info. List'
]
